/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_road_typology = /** @type {(inputs: {}) => string} */ () => {
	return `Straßentypologie`
};

const en_road_typology = /** @type {(inputs: {}) => string} */ () => {
	return `Road typology`
};

const es_road_typology = /** @type {(inputs: {}) => string} */ () => {
	return `Tipología de carreteras`
};

const fr_road_typology = /** @type {(inputs: {}) => string} */ () => {
	return `Typologie de route`
};

const it_road_typology = /** @type {(inputs: {}) => string} */ () => {
	return `Tipologia stradale`
};

const nl_road_typology = /** @type {(inputs: {}) => string} */ () => {
	return `Typologie van wegen`
};

const pt_road_typology = /** @type {(inputs: {}) => string} */ () => {
	return `Tipologia rodoviária`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const road_typology = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.road_typology(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("road_typology", locale)
	if (locale === "de") return de_road_typology(inputs)
	if (locale === "en") return en_road_typology(inputs)
	if (locale === "es") return es_road_typology(inputs)
	if (locale === "fr") return fr_road_typology(inputs)
	if (locale === "it") return it_road_typology(inputs)
	if (locale === "nl") return nl_road_typology(inputs)
	return pt_road_typology(inputs)
};